module.exports = __webpack_public_path__ + "static/media/Logo.7dab98b3.svg";